import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55a1a365"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-left fs-2 fw-bold mt-3 ms-2" }, "■グレード情報検索結果", -1 /* HOISTED */))
const _hoisted_3 = { class: "table table-striped mb-2 text-left-note" }
const _hoisted_4 = { class: "border-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "車台番号", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "車名", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "営業機種記号", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "グレード名", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "エンジン型式", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "過給有無", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "駆動方式", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "トランスミッション", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "衝突被害軽減ブレーキ", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "エアバッグ", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "モデル発売年月", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "検索ページに戻る", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note border border-2 text-left-note" }, [
  /*#__PURE__*/_createTextVNode(" ・特別仕様車や限定車など、一部正式名称でないグレード名が表示される場合があります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・検索結果はあくまでも参考情報であり、検索結果に対する責任は一切負いかねます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・検索結果につきましては、念のため日本自動車査定協会発行の資料などでご確認ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・最新機種は、グレード情報が表示されない場合があります。その場合は、後日改めてお問い合わせください。 ")
], -1 /* HOISTED */))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-left fs-2 fw-bold mt-3 ms-2" }, "■お問い合わせ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Header"]),
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", _hoisted_4, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", null, _toDisplayString($setup.vinNo), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", null, _toDisplayString($setup.typeName), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, _toDisplayString($setup.saleModel), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString($setup.grade), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_9,
          _createElementVNode("td", null, _toDisplayString($setup.engine), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, _toDisplayString($setup.turbo), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_11,
          _createElementVNode("td", null, _toDisplayString($setup.driveSys), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_12,
          _createElementVNode("td", null, _toDisplayString($setup.transmission), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", null, _toDisplayString($setup.EDB), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", null, _toDisplayString($setup.airbag), 1 /* TEXT */)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_15,
          _createElementVNode("td", null, _toDisplayString($setup.onsaleDate), 1 /* TEXT */)
        ])
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary btn-position mb-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toSearchGrade()))
    }, _hoisted_17),
    _hoisted_18,
    ($setup.notExistGradeData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              class: "fs-5 ms-3 manual-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openPDF()))
            }, " ＦＡＸ問い合わせ用紙(ＰＤＦ) ")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Footer"])
  ]))
}